import { useEffect, useRef, useState } from "react";
import { FriendlyCaptchaSDK } from "@friendlycaptcha/sdk";
import "./Captcha.css";

const Captcha = ({ onVerify, onError, onExpire, config }) => {
  const container = useRef(null);
  const sdkRef = useRef(null);
  const widgetRef = useRef(null);
  const [initialized, setInitialized] = useState(false);

  const initializeCaptcha = () => {
    if (initialized || widgetRef.current || !container.current || !config) {
      return;
    }

    const sitekey = config["captcha-site-key"];
    if (!sitekey) {
      console.error("Site key is missing");
      return;
    }

    // Initialize the SDK if it doesn't exist
    if (!sdkRef.current) {
      sdkRef.current = new FriendlyCaptchaSDK({
        apiEndpoint: "https://eu.frcapi.com/api/v2/captcha",
      });
    }

    // Create the widget
    if (sdkRef.current && sitekey) {
      const createdWidget = sdkRef.current.createWidget({
        element: container.current,
        sitekey,
        startMode: "auto",
      });

      // Add event listeners for widget events
      createdWidget.addEventListener("frc:widget.complete", (event) => {
        const response = event.detail.response;
        onVerify(response);
      });

      createdWidget.addEventListener("frc:widget.error", (event) => {
        console.error("Captcha error:", event.detail.error);
        onError?.(event.detail.error);
      });

      createdWidget.addEventListener("frc:widget.expire", () => {
        onExpire?.();
      });

      widgetRef.current = createdWidget;
      setInitialized(true);
    }
  };

  useEffect(() => {
    initializeCaptcha();

    return () => {
      if (widgetRef.current) {
        widgetRef.current = null;
        setInitialized(false);
      }
    };
  }, []);

  return <div ref={container} className="frc-captcha container" />;
};

export default Captcha;